export default __webpack_public_path__ + "static/media/N_Laminate.528dcd1d.jpg";